import { render } from "./ServiceTypesLegend.vue?vue&type=template&id=64c2fff2&scoped=true"
import script from "./ServiceTypesLegend.vue?vue&type=script&lang=js"
export * from "./ServiceTypesLegend.vue?vue&type=script&lang=js"

import "./ServiceTypesLegend.vue?vue&type=style&index=0&id=64c2fff2&scoped=true&lang=css"
import "./ServiceTypesLegend.vue?vue&type=style&index=1&id=64c2fff2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c2fff2"]])

export default __exports__